import { Alert, Box } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

const MissingInfoAlert = ({ formDetails }) => {
  return (
    <>
      {formDetails?.order_alert_message && (
        <Alert
          severity="warning"
          icon={false}
          sx={{
            mb: 3,
            backgroundColor: "#ffebee",
            color: "#d32f2f",
            border: "1px solid #eeeeee",
            borderRadius: "4px",
            fontSize: "0.8125rem",
            fontWeight: 400,
            opacity: 0.9,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 1,
            }}
          >
            <WarningIcon
              fontSize="small"
              color="error"
              sx={{
                mt: 0.1,
                fontSize: "17px",
              }}
            />
            <span>{formDetails?.order_alert_message}</span>
          </Box>
        </Alert>
      )}
    </>
  );
};

export default MissingInfoAlert;
